/**
 * @generated SignedSource<<0c26b093fbdf2611fa5f24a7c600ed47>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type designTemplatesQueriesMoveTemplateMutation$variables = {
  categoryId: number;
  templateIds: ReadonlyArray<number>;
};
export type designTemplatesQueriesMoveTemplateMutation$data = {
  readonly moveTemplates: ReadonlyArray<{
    readonly colors: ReadonlyArray<{
      readonly colorID: number;
      readonly isDefault: boolean;
      readonly name: string | null;
    } | null>;
    readonly designTemplateId: number;
    readonly id: string;
    readonly name: string;
    readonly previewUrl: string;
  }>;
};
export type designTemplatesQueriesMoveTemplateMutation = {
  response: designTemplatesQueriesMoveTemplateMutation$data;
  variables: designTemplatesQueriesMoveTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateIds"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "categoryId",
        "variableName": "categoryId"
      },
      {
        "kind": "Variable",
        "name": "templateIds",
        "variableName": "templateIds"
      }
    ],
    "concreteType": "DesignTemplate",
    "kind": "LinkedField",
    "name": "moveTemplates",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "designTemplateId",
        "storageKey": null
      },
      (v2/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "previewUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DesignTemplateColor",
        "kind": "LinkedField",
        "name": "colors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "colorID",
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDefault",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "designTemplatesQueriesMoveTemplateMutation",
    "selections": (v3/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "designTemplatesQueriesMoveTemplateMutation",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "cacheID": "e11390852ae43c17cf567ee6fb00027d",
    "id": null,
    "metadata": {},
    "name": "designTemplatesQueriesMoveTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation designTemplatesQueriesMoveTemplateMutation(\n  $templateIds: [Long!]!\n  $categoryId: Long!\n) {\n  moveTemplates(templateIds: $templateIds, categoryId: $categoryId) {\n    id\n    designTemplateId\n    name\n    previewUrl\n    colors {\n      colorID\n      name\n      isDefault\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1616a0b930e58c1c2cc035a59a90d0ab";

export default node;
